import React, { useEffect, useState } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { useStyle } from './PrequalStyle.js';
import {
    PREQUAL_BYPHONE_FAILED_TEXT_1,
    PREQUAL_BYPHONE_FAILED_TEXT_2,
    PREQUAL_BYPHONE_FAILED_TEXT_3,
} from './Constants';
import { getContext } from './EirPrequalUtil.js';
import { useLocalStorage } from './EirPrequalPersistance';
export default function EirPrequalNoResult(props) {
    const classes = useStyle();
    const { getLocalStorage, clearLocalStorage } = useLocalStorage();
    const [fontColor, setFontColor] = useState('');
    const [phone, setPhoneNumber] = useState({});
    let context = getContext();
    
    let prequalContext = getLocalStorage('currentContext')
        ? getLocalStorage('currentContext')
        : 'broadband';
    const setDataLayer = (title, url) => {
        dataLayer.push({
            event: 'VirtualPageview',
            virtualPageURL: url,
            virtualPageTitle: title,
        });
    };

    useEffect(() => {
        window.history.pushState(
            {},
            '',
            window.location.origin + `/${prequalContext}results/alternative/`
        );
        setDataLayer(
            `Post-Prequal Alternative Page| eir.ie`,
            `/${prequalContext}results/alternative/`
        );
        if (!fontColor) setFontColor(props.textFontColor);
        setPhoneNumber(getLocalStorage('phone'));
        if (!getLocalStorage('phone')) {
            window.location.href = `/${prequalContext}`;
        }
        return () => {
            clearLocalStorage('phone');
        };
    }, []);

    return (
        <div className={classes.PrequalFormContainer}>
            <div
                className={classes.PrequalBackGround}
                style={{
                    background: `url(${props.backgroundImage.path}) center top/100% 100% no-repeat`,
                }}>
                <div className={classes.PrequalContainer}>
                    <Grid className={classes.PrequalLeftPart}>
                        <Typography
                            className={classes.WeAreSorryHeadingText}
                            style={{ color: fontColor }}
                            variant={props.useH1 ? 'h1' : 'body1'}>
                            {props.title}
                        </Typography>

                        <Typography
                            className={classes.WeAreSorrySubHeadingText}
                            style={{ color: fontColor }}>
                            {props.text}
                        </Typography>

                        <Typography
                            className={classes.WeAreSorryPara1}
                            style={{ color: fontColor }}>
                            {PREQUAL_BYPHONE_FAILED_TEXT_1}{' '}
                            <strong>
                                {phone.areaCode} {phone.number}
                            </strong>
                        </Typography>

                        <div className={classes.WeAreSorryCTAButtonContainer}>
                            <Button
                                id='see_mobile_broadband'
                                disableRipple={true}
                                className={classes.WeAreSorryCTAButton}
                                onClick={() => {
                                    window.open(props.CTAurl, '_self');
                                }}>
                                {props.CTAtext}
                            </Button>
                        </div>

                        <Typography
                            className={classes.WeAreSorryPara2}
                            style={{ color: fontColor }}>
                            {PREQUAL_BYPHONE_FAILED_TEXT_2}{' '}
                            <span
                                className={classes.WeAreSorryPara2URL}
                                onClick={() => {
                                    window.open(`/${prequalContext}`, '_self');
                                }}>
                                {PREQUAL_BYPHONE_FAILED_TEXT_3}
                            </span>
                        </Typography>
                    </Grid>
                    <Grid className={classes.PrequalRightPart}>
                        <picture>
                            <source
                                media='(max-width: 1019px)'
                                srcSet={props.bannerImageMobile.path}
                            />
                            <img
                                className={classes.PrequalBanner}
                                src={props.bannerImageDesktop.path}
                                onError={event => {
                                    event.target.style.display = 'none';
                                }}
                            />
                        </picture>
                    </Grid>
                </div>
            </div>
            <picture>
                <source media='(max-width: 1019px)' srcSet={props.prequalBannerCurveMobile.path} />
                <img
                    className={classes.PrequalBannerCurve}
                    src={props.prequalBannerCurveDesktop.path}
                />
            </picture>
        </div>
    );
}
